const dictionaries = new Map();
const hashes = new Map();
const loadings = new Map();

export const Store = {
  getDictionariesMap: () => dictionaries,
  getHashesMap: () => hashes,
  getLoadingsMap: () => loadings
};
